export default __webpack_public_path__ + "static/blueonpink-09fc3d714f2b5e65ad17b5ae2dd2e549.png";